module.exports = __webpack_public_path__ + "img/coupon2022-sp@2x.cff66c7d.jpg";